



































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  Configuration,
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic
} from "@/configuration";
import API from "@/api";
import DniField from "@/components/DniFieldBusiness.vue";

@Component({
  metaInfo: {
    title: "Agendar llamada",
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  data() {
    return {
      RedCapital,
      SelectedCountry,
      valid: true,
      dialog: false,
      errorMessage: null,
      preference: "",
      phone: "",
      contactMessage: "",
      rules: {
        phone: [
          (v: any) => !/[^\d]/gim.test(v) || "Tiene que ser solo numeros",
          (v: any) => v.length == 9 || "El teléfono debe tener 9 números."
        ]
      },
      timePreference: ["Horario mañana", "Horario tarde", "Indiferente"]
    };
  },
  methods: {
    async validate(response) {
      // @ts-ignore
      if (this.$refs.form.validate()) {
        // @ts-ignore
        API.scheduleCall(
          `*AgendarLlamada - ${this.$route.params.requestId} - ${this.$data.preference} - ${this.$data.contactMessage}`,
          // @ts-ignore
          `${RedCapital[SelectedCountry].PhoneCode}${this.$data.phone}`
        )
          .then((data: any) => {
            this.$data.dialog = true;
            setTimeout(() => {
              this.$router.push({
                path: "/agenda-exitosa"
              });
            }, Configuration.Redirection.timeout);
          })
          .catch((res: any) => {
            this.$data.errorMessage = "Error";
          });
      }
    }
  },
  components: {
    DniField
  }
})
export default class ScheduleCall extends Vue {}
